import { TRIGGER_VALIDATE_PAN_API, TRIGGER_VALIDATE_PAN_API_SUCCESS } from 'redux/actionTypes';

export function triggerValidatePanApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_VALIDATE_PAN_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerValidatePanApiCallSuccess(data) {
	return {
		type: TRIGGER_VALIDATE_PAN_API_SUCCESS,
		data,
	};
}
